import { UserRoleEnum } from 'entities/index';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useUserRoleFromUrl = (): UserRoleEnum | null => {
  const location = useLocation();

  return useMemo(() => {
    const rolesWithoutUser = Object.values(UserRoleEnum).filter(
      (role) => role !== UserRoleEnum.USER
    );
    const rolesPattern = rolesWithoutUser.join('|');
    const regex = new RegExp(`\\b(${rolesPattern})\\b`, 'i');
    const match = location.pathname.match(regex);

    if (match) {
      return match[1].toLowerCase() as UserRoleEnum;
    }

    return null;
  }, [location.pathname]);
};
